<template>
  <div>
    <div class="view-header">
      <h1 class="is-size-5 is-expanded">
        Misc Request {{ $route.params.id ? "Edit" : "Add" }}
      </h1>
    </div>
    <div class="box">
      <div class="columns" v-if="role !== 'engineer'">
        <div class="column">
          <engineer-select v-model="misc.engineer"></engineer-select>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <input-field
            v-model="misc.startDate"
            label="From"
            type="date"
            :valid="startDateValid"
            required
          ></input-field>
        </div>
        <div class="column">
          <input-field
            v-model="misc.endDate"
            label="To"
            type="date"
            :valid="endDateValid"
            required
          ></input-field>
        </div>
      </div>
      <input-text
        label="Reason"
        v-model="misc.reason"
        :valid="reasonValid"
        required
      ></input-text>
      <p class="has-text-center has-text-danger">{{ errorMessage }}</p>
      <hr />
      <div class="is-flex">
        <div class="is-expanded">
          <button class="button is-borderless" @click="onCancelClicked">
            Cancel
          </button>
        </div>
        <div class="is-expanded has-text-right">
          <button
            class="button is-primary"
            :class="{ 'is-loading': loading }"
            :disabled="!formValid || loading"
            @click="onSaveClicked"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import validator from "validator"
import moment from "moment"
import EngineerSelect from "../../components/engineer-select"
export default {
  components: {
    EngineerSelect
  },
  data() {
    return {
      misc: {
        engineer: {},
        startDate: "",
        endDate: "",
        reason: ""
      },
      loading: false,
      errorMessage: ""
    }
  },
  methods: {
    onCancelClicked() {
      let component = this
      component.$router.go(-1)
    },
    onSaveClicked() {
      let component = this
      component.loading = true
      component.$store
        .dispatch(
          component.misc._id ? "misc/update" : "misc/store",
          component.misc
        )
        .then((response) => {
          component.$router.push(
            `/request/misc/view/${response.data.miscRequest._id}`
          )
        })
        .catch((error) => {
          console.log("fail")
          if (
            error.response.status === 500 &&
            error.response.data.error.code === 11000
          ) {
            component.errorMessage = error.response.data.error.errmsg
          }
        })
    }
  },
  computed: {
    role() {
      return localStorage.getItem("role")
    },
    engineerValid() {
      let component = this
      return component.misc.engineer._id !== undefined
    },
    startDateValid() {
      let component = this
      let _date = moment(component.misc.startDate)
      return _date.isValid()
    },
    endDateValid() {
      let component = this
      let _date = moment(component.misc.endDate)
      return _date.isValid()
    },
    reasonValid() {
      let component = this
      return component.misc.reason.length > 5
    },
    formValid() {
      let component = this
      let validationRules = [
        component.engineerValid,
        component.startDateValid,
        component.engineerValid,
        component.reasonValid
      ]
      for (let i = 0; i < validationRules.length; i++) {
        if (!validationRules[i]) {
          return false
        }
      }
      return true
    }
  },
  mounted() {
    let component = this
    component.loading = true
    if (component.$route.params.id) {
      component.$store
        .dispatch("misc/show", component.$route.params.id)
        .then((response) => {
          response.data.password = ""
          component.misc = response.data
          component.loading = false
        })
        .catch((error) => {
          console.log(error)
          component.loading = false
        })
    } else {
      if (localStorage.getItem("role") === "engineer") {
        component.misc.engineer = { _id: localStorage.getItem("user") }
      }
      component.loading = false
    }
  }
}
</script>
